import { RouteManager } from "./RouteManager";
import { Operation } from "./Operation";
import { BusinessPlan } from "./BusinessPlan";
import { FreightCosts } from "./FreightCosts";
import { FreightRevenue } from "./FreightRevenue";
import { Setting } from "./Setting";
import { AllocationCost } from "./AllocationCost";
import { Contructor } from "./Contructor";
import { Orders } from "./Orders";
import { IncurredCosts } from "./IncurredCosts";
import { TripClosing } from "./TripClosing";
import { Reports } from "./Reports";
import Vehicle from "./Vehicle";
import { Customer } from "./Customer";
import { DataLock } from "./DataLock";

export default {
  RouteManager,
  Operation,
  BusinessPlan,
  FreightCosts,
  FreightRevenue,
  Setting,
  AllocationCost,
  Contructor,
  Orders,
  IncurredCosts,
  TripClosing,
  Vehicle,
  Reports,
  Customer,
  DataLock,
};
